import React, { Fragment, useState, useEffect } from "react";
import { gAPI_THREAD_SUMMARY, gAPI_AZURE_THREAD_DYNAMIC_SUMMARY, gAPI_PROPERTIES } from "../../constants/api";
import CopyToClipboard from "react-copy-to-clipboard";
import searchImg from "../../assets/images/Search.png";
import moment from "moment";
import IntlMessage from "../helpers/IntlMessages";
import axios from 'axios';
const styles = ` <style>
          table { 
              width: 100%;
              border-collapse: collapse;
          }
        
          img {
              width: 150px;
              height: 100px;
          }

          .fui-FluentProviderr0 {
    --fontSizeBase300: 10px!mportant;
    --lineHeightBase300: 5px!mportant;
  }


      </style>`;

const tabStyles = ` <style>
    .nav-tabs { padding: 4px; }
    .nav-tabs .tab {
      padding: 6px 14px;
      min-width: 72px;
      display: inline-flex;
      align-items: center;
      justify-content: center;;
      cursor: pointer;
      user-select: none;
      background: #fff;
      color: #222;
    }
    .nav-tabs .tab.active {
      border-bottom: 2px solid #ef4a81;
      border-radius: 0px;
    }
  `;


const Search = ({ reply, gid, pid, cid, threadResponse, emailIntegration, handleManage, responseList, propertyDetails, questionSetDetails }) => {
  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState(false);
  const [activeTab, setActiveTab] = useState("search");
  const [propertyIntegration, setPropertyIntegration] = useState();
  // Using plain text spans as clickable tabs (Enter/Space supported)
  const handleTabKeyPress = (e, tab) => {
    if (e.key === "Enter" || e.key === " ") {
      setActiveTab(tab);
      e.preventDefault();
    }
  };
  const [roomsList, setRoomsList] = useState([]);
  const [selectedRoomData, setSelectedRoomData] = useState([]);
  const [selectedRatesData, setSelectedRatesData] = useState([]);
  const [startDate, setStartDate] = useState(
    threadResponse
      ? moment(threadResponse?.check_in_date).format("YYYY-MM-DD")
      : moment().add("days", 1).format("YYYY-MM-DD")
  );
  const [endDate, setEndDate] = useState(
    threadResponse
      ? moment(threadResponse?.check_out_date).format("YYYY-MM-DD")
      : moment().add("days", 2).format("YYYY-MM-DD")
  );
  const [bookingEngineUrl, setBookingEngineUrl] = useState("");
  const [adults, setAdults] = useState(threadResponse?.numberOfAdults || 2);
  const [childrens, setChildrens] = useState(threadResponse?.numberOfChildren || 0);
  const [specialCodes, setSpecialCodes] = useState(threadResponse?.promoCode || "");
  const [showModal, setShowModal] = useState(false);
  const [exactMatchCode, setExactMatchCode] = useState(false);
  const [showRateModal, setShowRateModal] = useState(false);
  const [showPriceWithTax, setShowPriceWithTax] = useState(false);
  const [ratesSearched, setRatesSearched] = useState(false);
  const [bookingEngineData, setBookingEngineData] = useState({ dateFormat: "", bookingUrl: "" });
  const [expandedRates, setExpandedRates] = useState([]);
  useEffect(() => {
    setSelectedRoomData([]);
    axios(`${process.env.REACT_APP_API_URL}/searchbookingengineurl?propertyId=${pid}&groupId=${gid}`, {
      method: "get",
    }).then(async (engineRes) => {
      const dateFormat = engineRes.data.result.dateFormat;
      let bookingUrl = engineRes.data.result.bookingUrl;
      setBookingEngineData({ dateFormat: dateFormat, bookingUrl: bookingUrl });
    });
  }, [pid]);


  const handleExactMatchCode = (e) => setExactMatchCode(e.target.checked);

  const closeRateModal = () => setShowRateModal(false);

  const openRateModal = () => setShowRateModal(true);

  const handleAvailability = () => {
    fetch(gAPI_PROPERTIES + `/${pid}/rooms`, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    })
      .then((response) => response.json())
      .then((res) => {
        let lstrooms = res?.rooms || [];
        let checkInDate = startDate;
        let checkOutDate = endDate;
        let group = '';
        let location = '';
        let responseFormat = '';
        let promoCode = specialCodes;
        let bestRate = false;
        let availableAreas = false;
        formatUrl({ group, location, promoCode });
        let rmsPropertyId = '';
        if (propertyIntegration?.Channel === 'Sabre') rmsPropertyId = pid;
        let availabilityurl = `${process.env.REACT_APP_PARTNER_URL}/public/availability/${propertyIntegration?.Id}?propertyId=${rmsPropertyId}&children=${childrens}&promoCode=${specialCodes}&availableAreas=${availableAreas}&bestRate=false&exactMatch=${exactMatchCode}&ratePlanCode=&channel=${propertyIntegration?.Channel}&rooms=1&group_id=${gid}&adults=${adults}&dateIn=${checkInDate}&dateOut=${checkOutDate}&discount=${0}`;
        fetch(availabilityurl, {
          method: "GET",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
        })
          .then((response) => response.json())
          .then((json) => {
            if (json.roomTypes !== undefined && json.roomTypes.length > 0) {
              json.roomTypes.map((m) => {
                let image = "";
                if (lstrooms !== undefined && lstrooms.length > 0) {
                  image =
                    lstrooms.filter(
                      (f) =>
                        (f?.provider === propertyIntegration?.Channel || f?.provider === "RMS") &&
                        f?.providerRoomCode == m?.roomTypeCode
                    )[0]?.images[0]?.url ?? "";
                }
                m.roomImage = image === "" ? m.roomImage : image;
              });
              setRoomsList(json.roomTypes);
              // setShowModal(true);
            }
            setLoading(false);
          })
          .catch(() => {
            setLoading(false);
          });
      });
  };

  const handleSelect = (id) => {
    let lst = [...selectedRoomData];
    if (lst?.includes(id) === true) setSelectedRoomData(lst?.filter((f) => f !== id));
    else {
      lst.push(id);
      setSelectedRoomData(lst);
    }
  };

  const handleSelectedRatesData = (roomTypeCode, ratePlanCode) => {
    let lst = [...selectedRatesData];
    if (lst?.some((item) => item.roomTypeCode === roomTypeCode && item.ratePlanCode === ratePlanCode) === true) setSelectedRatesData(lst?.filter((f) => !(f.roomTypeCode === roomTypeCode && f.ratePlanCode === ratePlanCode)));
    else {
      lst.push({ roomTypeCode, ratePlanCode });
      setSelectedRatesData(lst);
    }

  }

  const toggleRates = (roomTypeCode) => {
    let lst = [...expandedRates];
    if (lst?.includes(roomTypeCode) === true) setExpandedRates(lst?.filter((f) => f !== roomTypeCode));
    else {
      lst.push(roomTypeCode);
      setExpandedRates(lst);
    }
  };

  const formatPrice = (price, currency) => {
    if (price === undefined || price === null || price === "") return "";
    const num = Number(price);
    if (isNaN(num)) return price;
    return currency ? `${currency} ${num.toFixed(2)}` : num.toFixed(2);
  };

  const showRatesTemplatePreview = (index, roomName, roomDescription, roomTypeCode, roomImage, price, ratePlanCode, rates, currency) => {
    let text = ``;
    let description = roomDescription.length > 100 ? roomDescription.substring(0, 100) + "...." : roomDescription;
    const otherRates = (rates || []).filter((rt) => rt?.ratePlanCode !== ratePlanCode);
    const count = otherRates.length;
    const nights = moment(endDate).diff(moment(startDate), "days");
    // text = text.replace("{roomImage}", roomImage);
    // text = text.replace("{ratePlan}", ratePlanCode);
    // text = text.replace("{roomDescription}", description);
    // text = text.replace("{roomName}", roomName);
    return (
      <Fragment>
        <div
          className="row mx-0"
          style={{
            border: "1px solid grey",
            // borderColor: `${selectedRoomData.includes(roomTypeCode) ? "green" : "black"}`,
            // borderWidth: `${selectedRoomData.includes(roomTypeCode) ? "2px" : "1px"}`,
            verticalAlign: "top",
            marginTop: "0.25rem",
            position: "relative",
          }}
        // onClick={() => handleSelect(roomTypeCode)}
        >
          {roomImage && roomImage !== "" ? (
            <div className="col-5" style={{ padding: "5px" }}>
              <img
                src={roomImage}
                alt="Room 1"
                style={{ width: "100%", height: "100%", objectFit: "cover" }}
              />
            </div>
          ) : null}
          <div className={roomImage && roomImage !== "" ? "col-7" : "col-12 ml-2"} style={{ padding: "0px 0px 10px" }}>
            <h5 style={{ margin: 0, fontSize: "13px", color: "#333", marginTop: "0.5rem" }}><b>{roomName}</b></h5>
            <div className="row" style={{ position: "absolute", right: "10px", marginTop: "0px", cursor: "pointer" }}>
              <svg
                onClick={() => handleSelectedRatesData(roomTypeCode, ratePlanCode)}
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth="1.5"
                stroke="currentColor"
                width={25}
                height={25}
                style={{ fill: `${selectedRatesData.some(data => data.roomTypeCode === roomTypeCode && data.ratePlanCode === ratePlanCode) ? "lightgreen" : "white"}` }}
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M9 12.75 11.25 15 15 9.75M21 12c0 1.268-.63 2.39-1.593 3.068a3.745 3.745 0 0 1-1.043 3.296 3.745 3.745 0 0 1-3.296 1.043A3.745 3.745 0 0 1 12 21c-1.268 0-2.39-.63-3.068-1.593a3.746 3.746 0 0 1-3.296-1.043 3.745 3.745 0 0 1-1.043-3.296A3.745 3.745 0 0 1 3 12c0-1.268.63-2.39 1.593-3.068a3.745 3.745 0 0 1 1.043-3.296 3.746 3.746 0 0 1 3.296-1.043A3.746 3.746 0 0 1 12 3c1.268 0 2.39.63 3.068 1.593a3.746 3.746 0 0 1 3.296 1.043 3.746 3.746 0 0 1 1.043 3.296A3.745 3.745 0 0 1 21 12Z"
                />
              </svg>
            </div>
            <h6 style={{ margin: "0", fontSize: "11px", color: "#555", lineHeight: "12px" }} className="mt-1">{description}</h6>
            {/* <p style={{ margin: "5px 0", fontSize: "14px", color: "#555" }}>
             <IntlMessage id="main.total" />  : <b>{(price)}</b>
            </p> */}
            <div style={{ margin: "5px 0", fontSize: "14px", color: "#555" }}>
               {/* <IntlMessage id="main.total" />:{" "} */}
            <p style={{marginBottom:"0px", fontSize: "11px",}}> {currency}{" "} 
              <b>
                {`${formatPrice(calculatePrice(price))}/night`}
              </b></p>
             <p style={{marginBottom:"0px", fontSize: "11px",}}> {` ${nights} ${nights === 1 ? "night" : "nights"}: `}
              <b>{formatPrice(price)}</b></p>
            </div>
            {count > 0 && (
              <p style={{ margin: "5px 0", fontSize: "12px", color: "#007bff", cursor: "pointer", textDecoration: "underline" }}>
                <span onClick={() => toggleRates(roomTypeCode)}>
                  {expandedRates.includes(roomTypeCode) ? "Hide rates" : `${count} more rate${count > 1 ? "s" : ""}`}
                </span>
              </p>
            )}
          </div>
        </div>
        {expandedRates.includes(roomTypeCode) && (
          <div >
            {otherRates.map((rt, idx) => (
              <div
                className="row mx-0"
                style={{
                  border: "1px solid grey",
                  // borderColor: `${selectedRoomData.includes(roomTypeCode) ? "green" : "black"}`,
                  // borderWidth: `${selectedRoomData.includes(roomTypeCode) ? "2px" : "1px"}`,
                  verticalAlign: "top",
                  marginTop: 8,
                  position: "relative",
                }}
              // onClick={() => handleSelect(roomTypeCode)}
              >
                <div className="col-12" style={{ padding: "5px" }}>        
                  <div className="row" style={{ position: "absolute", right: "10px", marginTop: "0px", cursor: "pointer" }}>
                    <svg
                      onClick={() => handleSelectedRatesData(roomTypeCode, rt?.ratePlanCode)}
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      strokeWidth="1.5"
                      stroke="currentColor"
                      width={25}
                      height={25}
                      style={{ fill: `${selectedRatesData.some(data => data.roomTypeCode === roomTypeCode && data.ratePlanCode === rt?.ratePlanCode) ? "lightgreen" : "white"}` }}
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M9 12.75 11.25 15 15 9.75M21 12c0 1.268-.63 2.39-1.593 3.068a3.745 3.745 0 0 1-1.043 3.296 3.745 3.745 0 0 1-3.296 1.043A3.745 3.745 0 0 1 12 21c-1.268 0-2.39-.63-3.068-1.593a3.746 3.746 0 0 1-3.296-1.043 3.745 3.745 0 0 1-1.043-3.296A3.745 3.745 0 0 1 3 12c0-1.268.63-2.39 1.593-3.068a3.745 3.745 0 0 1 1.043-3.296 3.746 3.746 0 0 1 3.296-1.043A3.746 3.746 0 0 1 12 3c1.268 0 2.39.63 3.068 1.593a3.746 3.746 0 0 1 3.296 1.043 3.746 3.746 0 0 1 1.043 3.296A3.745 3.745 0 0 1 21 12Z"
                      />
                    </svg>
                  </div>
                  <div style={{ fontSize: "11px", color: "#555" }}>{rt?.ratePlanName || rt?.ratePlanCode}</div>
                   <div style={{ fontSize: "14px", color: "#555" }}>
                    {(() => {
                      const totalPrice = showPriceWithTax
                        ? (rt?.amountAfterTaxAndFees ?? rt?.price)
                        : (rt?.amountBeforeTaxAndFees ?? rt?.price);

                      return (
                            <>
                   <p style={{marginBottom:"0px", fontSize: "11px",}}>{currency}{" "}
                          <b>{`${formatPrice(calculatePrice(totalPrice))}/night`}</b></p>
                         <p style={{marginBottom:"0px", fontSize: "11px",}}>   {` ${nights} ${nights === 1 ? "night" : "nights"}: `}
                          <b>{formatPrice(totalPrice)}</b></p>
                        </>
                      );
                    })()}
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </Fragment>
    );
  };

  const handleStartDate = (e) => setStartDate(e.target.value);

  const handleEndDate = (e) => setEndDate(e.target.value);

  const handleAdults = (e) => setAdults(e.target.value);

  const handleChildrens = (e) => setChildrens(e.target.value);

  const handleSpecialCodes = (e) => setSpecialCodes(e.target.value);

  const handleSubmit = () => {
    setShowRateModal(false);
    setShowModal(true);
    setLoading(true);
    setRatesSearched(true);
    handleAvailability();
  };

  const formatUrl = ({ group, location, promoCode }) => {
    let bookingUrl = bookingEngineData?.bookingUrl;
    let dateFormat = bookingEngineData?.dateFormat;
    bookingUrl = bookingUrl.replace("{CHECK_IN}", moment(startDate).format(dateFormat));
    bookingUrl = bookingUrl.replace("{CHECK_OUT}", moment(endDate).format(dateFormat));
    bookingUrl = bookingUrl.replace("{ADULTS}", adults);
    bookingUrl = bookingUrl.replace("{CHILDREN}", childrens);
    bookingUrl = bookingUrl.replace("{categoryGroup}", group);
    bookingUrl = bookingUrl.replace("{location}", location);
    bookingUrl = bookingUrl.replace("{LANGUAGE}", "en");
    bookingUrl = bookingUrl.replace("{PromoCode}", specialCodes);
    bookingUrl = bookingUrl.replace("{ROOM_TYPE}", "");
    setBookingEngineUrl(bookingUrl);
  };
  const handleRoomList = () => {
    fetch(gAPI_PROPERTIES + `/${pid}/rooms`, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    })
      .then((response) => response.json())
      .then((json) => {
        setRoomsList(json?.rooms || []);
        setSelectedRoomData([]);
      });
  };

  const showTemplatePreview = (index, roomName, roomDescription, id, roomImage, roomTypeCode) => {
    let text = ``;
    let description = roomDescription.length > 100 ? roomDescription.substring(0, 100) + "...." : roomDescription;
    text = text.replace("{roomImage}", roomImage);
    text = text.replace("{ratePlan}", id);
    text = text.replace("{roomDescription}", description);
    text = text.replace("{roomName}", roomName);
    return (
      <Fragment>
        <div
          className="row mx-0"
          style={{
            border: "1px solid grey",
            // borderColor: `${selectedRoomData.includes(id) ? "green" : "black"}`,
            // borderWidth: `${selectedRoomData.includes(id) ? "2px" : "1px"}`,
            verticalAlign: "top",
            marginTop: "0.25rem",
            position: "relative"
          }}
        // onClick={() => handleSelect(id)}
        >
          {roomImage && roomImage !== "" ? (
            <div className="col-5" style={{ padding: "5px" }}>
              <img
                src={roomImage}
                alt="Room 1"
                style={{ width: "100%", height: "100%", objectFit: "cover" }}
              />
            </div>
          ) : null}
          <div className={roomImage && roomImage !== "" ? "col-7" : "col-12 ml-2"} style={{ padding: "0px 0px 10px" }}>
            <h5 style={{ margin: 0, fontSize: "13px", color: "#333", marginTop: "0.5rem" }}><b>{roomName}</b></h5>
            <div className="row" style={{ position: "absolute", right: "10px", marginTop: "0px", cursor: "pointer" }}>
              <svg
                onClick={() => handleSelect(id)}
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth="1.5"
                stroke="currentColor"
                width={25}
                height={25}
                style={{ fill: `${selectedRoomData?.includes(id) ? "lightgreen" : "white"}` }}
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M9 12.75 11.25 15 15 9.75M21 12c0 1.268-.63 2.39-1.593 3.068a3.745 3.745 0 0 1-1.043 3.296 3.745 3.745 0 0 1-3.296 1.043A3.745 3.745 0 0 1 12 21c-1.268 0-2.39-.63-3.068-1.593a3.746 3.746 0 0 1-3.296-1.043 3.745 3.745 0 0 1-1.043-3.296A3.745 3.745 0 0 1 3 12c0-1.268.63-2.39 1.593-3.068a3.745 3.745 0 0 1 1.043-3.296 3.746 3.746 0 0 1 3.296-1.043A3.746 3.746 0 0 1 12 3c1.268 0 2.39.63 3.068 1.593a3.746 3.746 0 0 1 3.296 1.043 3.746 3.746 0 0 1 1.043 3.296A3.745 3.745 0 0 1 21 12Z"
                />
              </svg>
            </div>
            <h6 style={{ margin: "0", fontSize: "11px", color: "#555", lineHeight: "12px" }} className="mt-1">{roomDescription}</h6>
            {/* <p style={{ margin: "5px 0", fontSize: "14px", color: "#555" }}>
                        Rateplan: <b>{ratePlan}</b>
                      </p>  */}
          </div>
        </div>
        {/* <tr>
              <td style={{ border: "1px solid black", verticalAlign: "top", marginTop: "0.25rem" }}>
                <table>
                  <tr>
                    <td>
                      
                    </td>
                    <td style={{ padding: "5px 10px" }}>
    
                    </td>
                  </tr>
                </table>
              </td>
            </tr> */}
      </Fragment>
    );
  };

  const handleSearch = () => {
    let url = `${questionSetDetails?.openAiModel === "AzureGpt4" ? gAPI_AZURE_THREAD_DYNAMIC_SUMMARY : gAPI_THREAD_SUMMARY}`;
    setLoading(true);
    fetch(url, {
      method: "Post",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        groupId: gid,
        propertyId: pid,
        language: "en",
        q: search,
        verbosity: questionSetDetails?.openAiVerbosity,
        indexVersion: propertyDetails?.searchIndexVersion,
        index: propertyDetails?.searchIndexName,
        suffix: `You are a Chatbot working as an employee at ${propertyDetails?.name}. When responding, always refer to the hotel as \"we\" or \"our.\"`,
        conversationId: cid,
        propertyName: propertyDetails?.name,
        modelName: questionSetDetails?.openAiModel === "AzureGpt4" ? "gpt-4o-mini" : questionSetDetails?.openAiModel,
        history: [],
      }),
    })
      .then((res) => res.json())
      .then(async (result) => {
        if (result.arguments !== undefined) {
          let data = JSON.parse(result.arguments);
          let lst = [...responseList];
          lst.push(data?.response);
          handleManage("responseList", lst);
          setLoading(false);
          setSearch("");
        }
      });
  };

  const handleAppendContent = (value) => {
    let lst = [...responseList];
    lst.push(value);
    handleManage("responseList", lst);
  };
  const calculatePrice = (price) => {
    let diff = moment(endDate).diff(moment(startDate), "days");
    return Math.round((price / diff) * 100) / 100;
  };
  const handleOutlookContent = async (value) => {
    const ratesHtml = `<table><tr><td>${value}</td></tr></table>`;
    const signatures = [
      "Best regards,",
      "Warm regards,",
      "Kind regards,",
      "Regards,",
      "Sincerely,",
      "Thanks,",
      "Thank you,",
      "Warmly,",
      "Faithfully,",
      "Best wishes,",
      "Your's Sincerely,",
      "Your's Faithfully,",
      "Mahalo,",
    ];

    let updatedReply = reply;

    const searchStart = Math.max(0, reply.length - 500);
    const tail = reply.substring(searchStart);

    const signature = signatures.find(sig => tail.includes(sig));

    if (signature) {
      const index = reply.lastIndexOf(signature);

      updatedReply =
        reply.slice(0, index) +
        `${ratesHtml}<br><br>` +
        reply.slice(index);
    } else {
      updatedReply += `<br><br>${ratesHtml}`;
    }
    await Office.context.mailbox.item.displayReplyFormAsync(updatedReply);

  };
  useEffect(() => {
    if (activeTab === "rates" && gid && pid) {
      fetch(`${process.env.REACT_APP_API_URL}/find-by-property?propertyId=${pid}&groupId=${gid}`)
        .then((res) => res.json())
        .then((data) => setPropertyIntegration(data))
        .catch(() => { });
    }
  }, [activeTab, gid, pid]);
  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      handleSearch(search);
    }
  };
  const handleChange = (e) => setSearch(e.target.value);
  const handleReply = async (content) => {
    const popupWindow = await Office.context.mailbox.item.displayReplyFormAsync(content);
    handleManage("updateStats", {
      pasteToOutlook: true,
      replyGenerated: mailStatsChange?.replyGenerated,
      copyDraft: mailStatsChange?.copyDraft,
    });
  };

  const handleAddRooms = () => {
    setLoading(true);
    let text =
      "<p>Explore our available room types below:</p><hr style='margin: 10px 0;' /><table>";
    roomsList
      .filter((f) => selectedRoomData.includes(f?.id))
      .forEach((d) => {
        const imageContent = d?.images?.[0]?.url
          ? `<img src="${d.images[0].url}" alt="Room Image"
              style="width:150px;height:auto;" />`
          : `<div style="width:150px;height:100px;border:1px solid #ccc;
              display:flex;align-items:center;justify-content:center;
              color:#777;font-size:14px;">
              Image Not Available
            </div>`;

        text += `
          <tr>
            <td style="border:1px solid black; vertical-align:top;">
              <table>
                <tr>
                  <td>
                    ${imageContent}
                  </td>
                  <td style="padding:5px 10px;">
                    <h6 style="margin:0; color:#333;">
                      ${d?.roomTypeName || ""}
                    </h6>

                    <p style="margin:5px 0; font-size:16px; color:#555;">
                      <b>${d?.name || ""}</b>
                    </p>

                    <p style="margin:5px 0; font-size:14px; color:#555;">
                      ${d?.description
            ? d.description.length > 100
              ? d.description.substring(0, 100) + "..."
              : d.description
            : ""
          }
                    </p>
                  </td>
                </tr>
              </table>
            </td>
          </tr>`;
      });

    text += "</table>";
    setShowModal(false);
    handleOutlookContent(text);
    setLoading(false);
  };
  const handleAddRates = () => {
    setLoading(true);
    console.log(bookingEngineUrl, 'bookingEngineUrl', roomsList, selectedRoomData);
    let text = `<p>Here are the available rates for ${adults} adults and ${childrens} children from ${startDate} to ${endDate}. <a style='fontSize: 14px;'  href='${bookingEngineUrl}'>Book Here</a> </p><hr/><table>`;
    let diff = moment(endDate).diff(moment(startDate), "days");
    selectedRatesData
      .map((d, index) => {
        let roomType = roomsList.filter((f) => f?.roomTypeCode === d?.roomTypeCode)[0];
        let r = roomType?.rates?.filter((f) => d.ratePlanCode === f?.ratePlanCode)[0];
        const imageContent = roomType?.roomImage
          ? `<img src="${roomType?.roomImage}" alt="Room Image"
              style="width:150px;height:auto;" />`
          : ``;
        text += `<tr><td style='border: 1px solid black;verticalAlign: top'><table><tr><td>
              ${imageContent}
              </td><td style='padding:5px 10px'>                            
              <h5 style='margin: 0'}}><b>${roomType?.roomTypeName || ""}</b></h5>
              <p style='margin: 5px 0; font-size: 14px; '>${r?.ratePlanName}</p>
              <p style='margin: 5px 0; font-size: 14px; '>${roomType?.currencyCode} ${formatPrice(calculatePrice(showPriceWithTax ? (r?.amountAfterTaxAndFees ?? r?.price) : (r?.amountBeforeTaxAndFees ?? r?.price)))} per night | ${diff} nights: ${formatPrice(showPriceWithTax ? (r?.amountAfterTaxAndFees ?? r?.price) : (r?.amountBeforeTaxAndFees ?? r?.price))} (${showPriceWithTax ? "incl. taxes & fees" : "excl. taxes & fees"})</p>              
                </td></tr></table></td></tr>`;
        setShowModal(false);
      });
    text += "</table>";
    handleOutlookContent(text);
    setLoading(false);
  };

  return (
    <Fragment>
      <div className="page-content header-clear-small" style={{ position: "relative" }}>
        {loading && (
          <div
            className="global-loader"
            role="status"
            aria-live="polite"
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              background: "rgba(255,255,255,0.7)",
              zIndex: 999,
            }}
          >
            <div className="spinner-border color-highlight-myma" role="status" style={{ height: "2rem", width: "2rem" }}></div>
          </div>
        )}
        <div className="row">
          <div className="col-md-12">
            <div style={{ marginBottom: 10 }}>
              <style>{tabStyles}</style>
              <ul className="nav-tabs" role="tablist" style={{ display: "flex", justifyContent: 'center', gap: 8, paddingInlineStart: 0, margin: 0 }}>
                <li className="nav-item" style={{ listStyle: "none" }}>
                  <span
                    role="tab"
                    aria-selected={activeTab === "search"}
                    className={`tab ${activeTab === "search" ? "active" : ""}`}
                    tabIndex={0}
                    onClick={() => setActiveTab("search")}
                    onKeyDown={(e) => handleTabKeyPress(e, "search")}
                  >
                 <IntlMessage id= "footer.knowledge" />
                  </span>
                </li>
                {emailIntegration?.channelDetails?.showRoomsButton === true && (
                  <li className="nav-item" style={{ listStyle: "none" }}>
                    <span
                      role="tab"
                      aria-selected={activeTab === "rooms"}
                      className={`tab ${activeTab === "rooms" ? "active" : ""}`}
                      tabIndex={0}
                      onClick={() => { handleRoomList(); setActiveTab("rooms") }}
                      onKeyDown={(e) => handleTabKeyPress(e, "rooms")}
                    >
                       <IntlMessage id= "main.rooms" />
                    </span>
                  </li>
                )}
                {emailIntegration?.channelDetails?.showRatesButton === true && (
                  <li className="nav-item" style={{ listStyle: "none" }}>
                    <span
                      role="tab"
                      aria-selected={activeTab === "rates"}
                      className={`tab ${activeTab === "rates" ? "active" : ""}`}
                      tabIndex={0}
                      onClick={() => { setRoomsList([]); openRateModal(); setActiveTab("rates") }}
                      onKeyDown={(e) => handleTabKeyPress(e, "rates")}
                    >
                        <IntlMessage id= "main.rates" />
                    </span>
                  </li>)}
              </ul>
            </div>
          </div>
        </div>
        {/* <div className="row">
                      <div className="col-md-12 text-center">
                          <div className="form-field form-email">
                              <input type="text" onChange={handleChange} name="" placeholder="Search" value={search} className="round-small" id="contactEmailField" />
                          </div>
                      </div>
                  </div>
                  <div className="col-md-12 text-center my-2">
                      <div className="form-button">
                          <input type="button" onClick={() => handleSearch(search)} className="btn-full btn border-myma button-myma-primary" value="Submit" />
                      </div>
                  </div> */}

        <div className="col-md-12">
          {activeTab === "search" ? (
            loading ? (
              <div className="preloader-show item-center">
                <div
                  className="spinner-border color-highlight-myma"
                  role="status"
                  style={{ height: "1.5rem", width: "1.5rem" }}
                ></div>
              </div>
            ) : (
              <Fragment>
                <div className="row search-box ml-2">
                  <div className="col-md-12 ">
                    <div className=" form-email-box" style={{ display: "flex" }}>
                      <input
                        id="contactEmailField"
                        type="text"
                        style={{ width: "80%" }}
                        onKeyDown={handleKeyDown}
                        onChange={handleChange}
                        name=""
                        placeholder="Enter a search phrase…"
                        value={search}
                      />

                      <button
                        className="btn-full btn  form-button button-default-primary"
                        type="button"
                        onClick={() => handleSearch(search)}
                        style={{ width: "15%", marginRight: "10px" }}
                      >
                        <svg
                          className="mb-1"
                          xmlns="http://www.w3.org/2000/svg"
                          fill="none"
                          viewBox="0 0 24 24"
                          stroke-width="2.25"
                          stroke="currentColor"
                          width={20}
                          height={20}
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            d="m21 21-5.197-5.197m0 0A7.5 7.5 0 1 0 5.196 5.196a7.5 7.5 0 0 0 10.607 10.607Z"
                          />
                        </svg>
                      </button>
                    </div>
                  </div>
                </div>
                {responseList.length > 0 ? (
                  <Fragment>
                    {responseList.map((m, index) => (
                      <div key={index} className="text-center mt-2">
                        <div className="card card-mobile-style">
                          <div className="content row mx-0">
                            <div className="col-md-12 mb-2">
                              <CopyToClipboard text={m}>
                                <button
                                  type="submit"
                                  style={{
                                    float: "right",
                                    color: "grey",
                                    border: "none",
                                    background: "transparent",
                                    padding: "10px 21px 0px 0px",
                                  }}
                                >
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    fill="none"
                                    viewBox="0 0 24 24"
                                    strokeWidth="1.5"
                                    stroke="currentColor"
                                    width={20}
                                    height={20}
                                  >
                                    <path
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      d="M15.75 17.25v3.375c0 .621-.504 1.125-1.125 1.125h-9.75a1.125 1.125 0 0 1-1.125-1.125V7.875c0-.621.504-1.125 1.125-1.125H6.75a9.06 9.06 0 0 1 1.5.124m7.5 10.376h3.375c.621 0 1.125-.504 1.125-1.125V11.25c0-4.46-3.243-8.161-7.5-8.876a9.06 9.06 0 0 0-1.5-.124H9.375c-.621 0-1.125.504-1.125 1.125v3.5m7.5 10.375H9.375a1.125 1.125 0 0 1-1.125-1.125v-9.25m12 6.625v-1.875a3.375 3.375 0 0 0-3.375-3.375h-1.5a1.125 1.125 0 0 1-1.125-1.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H9.75"
                                    />
                                  </svg>
                                </button>
                              </CopyToClipboard>
                            </div>
                            <div className="col-md-12 mb-2">
                              <p className="mb-2" style={{ cursor: "pointer", color: `${reply === m ? "#ef4A81" : "black"}` }}>
                                {m}
                              </p>
                            </div>
                            <div className="item-center" style={{ width: '80%' }}>
                              <button
                                type="button"
                                onClick={() => handleReply(m)}
                                className="btn-full btn border-green-dark reply-button"
                                style={{ padding: "6px" }}
                              >
                                <span className="ml-1" style={{ textTransform: "none" }}>
                                 <IntlMessage id="main.pastetooutlook" />
                                </span>
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    ))}
                  </Fragment>
                ) : (
                  <div className="item-center">
                    <img src={searchImg} style={{ width: "90%", height: "90%" }} alt="search" />
                  </div>
                )}
              </Fragment>
            )
          ) : activeTab === "rooms" ? (
            <div style={{ padding: 8 }}>
              <style>{styles}</style>
              {loading ? (
                <div className="col-12">
                  <div id="ari-rooms-loader" className="preloader-show col-12">
                    <div
                      className="spinner-border color-highlight-myma"
                      role="status"
                      style={{ height: "1.5rem", width: "1.5rem" }}
                    ></div>
                  </div>
                </div>
              ) : (
                <Fragment>
                  <div className="col-12" style={{ padding: "0px 10px", overflowY: "scroll" }}>
                    {roomsList !== undefined && roomsList.length > 0 && (
                      <Fragment>
                        <div className="mb-4" >
                          {roomsList.map((d, index) => (
                            <Fragment>
                              {showTemplatePreview(
                                index,
                                d?.name || "",
                                (d?.description?.length > 100 ? d?.description?.substring(0, 100) : d?.description) || "",
                                d?.id || "",
                                d?.images?.[0]?.url || "",
                                d?.roomTypeCode || ""
                              )}
                            </Fragment>
                          ))}
                        </div>
                        <div
                          className="item-center"
                          style={{
                            width: "90%",
                            position: "fixed",
                            bottom: "60px",
                            background: "white",
                            padding: "10px 0",
                            zIndex: 10,
                          }}
                        >
                          <button
                            type="button"
                            onClick={handleAddRooms}
                            className="btn-full btn border-green-dark reply-button paste-button"
                            style={{ padding: "6px" }}
                          >
                            <span className="ml-1" style={{ textTransform: "none" }}>
                                <IntlMessage id="main.pastetooutlook" />
                            </span>
                          </button>
                        </div>
                      </Fragment>
                    )}
                  </div>
                </Fragment>
              )}
            </div>
          ) : (
            <div style={{ padding: 8 }}>
              {showRateModal && (
                <div
                  className="row additional-modal"
                  style={{
                    height: "70%",
                    position: "fixed",
                    top: "40px",
                    left: "0px",
                    right: "0px",
                    padding: '0.5rem'
                  }}
                >
                  <div className="modal-box">
                    <div className="col-12">
                      <div className="row mb-3" style={{ margin: "5px" }}>
                        <div className="form-custom form-label mb-3">
                          <input
                            type="date"
                            onChange={handleStartDate}
                            value={startDate}
                            className="form-control rounded-xs  form-control"
                            id="startDate"
                            min={moment().format("YYYY-MM-DD")}
                          />
                          <label className="color-theme form-label-active"><IntlMessage id= "main.check_in" /></label>
                        </div>
                        <div className="form-custom form-label mb-3">
                          <input
                            type="date"
                            onChange={handleEndDate}
                            value={endDate}
                            className="form-control rounded-xs  form-control"
                            id="endDate"
                            min={moment().format("YYYY-MM-DD")}
                          />
                          <label className="color-theme form-label-active"><IntlMessage id= "main.check_out" />
                          </label>
                        </div>
                        <div className="form-custom form-label mb-3">
                          <input
                            type="number"
                            onChange={handleAdults}
                            value={adults}
                            className="form-control rounded-xs  form-control"
                            id="adults"
                            min={1}
                          />
                          <label className="color-theme form-label-active"><IntlMessage id= "main.adults" /></label>
                        </div>
                        <div className="form-custom form-label mb-3">
                          <input
                            type="number"
                            onChange={handleChildrens}
                            value={childrens}
                            className="form-control rounded-xs  form-control"
                            id="childrens"
                            min={0}
                          />
                          <label className="color-theme form-label-active"><IntlMessage id="main.children" /></label>
                        </div>
                        <div className="form-custom form-label mb-3">
                          <input
                            type="text"
                            onChange={handleSpecialCodes}
                            value={specialCodes}
                            className="form-control rounded-xs  form-control"
                            id="specialCodes"
                          />
                          <label className="color-theme form-label-active"><IntlMessage id="main.promocode" /></label>
                        </div>
                        {specialCodes && specialCodes !== "" && (
                          <div className="mb-3 exact-match">
                            <input
                              type="checkbox"
                              onChange={handleExactMatchCode}
                              checked={exactMatchCode}
                              className=""
                              id="exactMatchCode"
                            />
                            <label
                              htmlFor="exactMatchCode"
                              className="color-theme form-label-active"
                              style={{ fontWeight: 600 }}
                            >
                              <IntlMessage id="main.exact_match_only" />
                            </label>
                          </div>)}
                      </div>
                    </div>
                    <div className="col-12">
                      <button
                        type="submit"
                        onClick={handleSubmit}
                        className="btn-full btn border-green-dark reply-button"
                        style={{ padding: "6px" }}
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          fill="none"
                          viewBox="0 0 24 24"
                          strokeWidth="1.5"
                          stroke="currentColor"
                          width={15}
                          height={15}
                        >
                          <path d="M6,14.1818182 L6,17.4545455 L18,17.4545455 L18,14.1818182 M12,6 L12,14 M8.18181818,9.81818182 L12,6 L15.8181818,9.81818182" />
                        </svg>
                        <span className="ml-1" style={{ textTransform: "none" }}>
                         <IntlMessage id="main.search" />
                        </span>
                      </button>
                    </div>
                  </div>
                  <button className="close-btn" onClick={closeRateModal}>
                    &times;
                  </button>
                </div>
              )}
              <Fragment>
                <div className="col-12" style={{ padding: "0px 10px", overflowY: "scroll" }}>
                  {roomsList !== undefined && roomsList.length > 0 ? (
                    <Fragment>
                      <div style={{ display: "flex", marginBottom: 10 }}>
                        <label style={{ display: "flex", alignItems: "center", gap: "8px", cursor: "pointer", textDecoration: "underline" }} onClick={() => setShowPriceWithTax(!showPriceWithTax)}>
                          <span>{!showPriceWithTax ? "Show rates including taxes & fees" : "Show rates without taxes & fees"}</span>
                        </label>
                      </div>
                      <div className="mb-4">
                        {roomsList.map((d, index) => (
                          <Fragment key={index}>
                            {showRatesTemplatePreview(
                              index,
                              d?.roomTypeName || "",
                              d?.minimumRate?.ratePlanName || "",
                              d?.roomTypeCode || "",
                              d?.roomImage || "",
                              showPriceWithTax ? (d?.minimumRate?.amountAfterTaxAndFees ?? d?.minimumRate?.price) : (d?.minimumRate?.amountBeforeTaxAndFees ?? d?.minimumRate?.price),
                              d?.minimumRate?.ratePlanCode || "",
                              d.rates,
                              d?.currencyCode
                            )}
                          </Fragment>
                        ))}
                      </div>
                      <div
                        className="item-center"
                        style={{
                          width: "90%",
                          position: "fixed",
                          bottom: "60px",
                          background: "white",
                          padding: "10px 0",
                          zIndex: 10,
                        }}
                      >
                        <button
                          type="button"
                          onClick={handleAddRates}
                          className="btn-full btn border-green-dark reply-button paste-button"
                          style={{ padding: "6px" }}
                        >
                          <span className="ml-1" style={{ textTransform: "none" }}>
                             <IntlMessage id="main.pastetooutlook" />
                          </span>
                        </button>
                      </div>
                    </Fragment>
                  ) : (
                    <Fragment>
                      {ratesSearched && !loading && (
                        <div style={{ padding: "20px", textAlign: "center", color: "#777" }}>
                        <IntlMessage id="main.no_rate_match"  />
                        </div>
                      )}
                    </Fragment>
                  )}

                </div>
              </Fragment>
            </div>
          )}
        </div>
      </div>
    </Fragment>
  );
};

export default Search;
